export const colors = {
  ihk_darkblue: "#1A4675",
  ihk_lightblue: "#d2dcea",
  ihk_green: "#afcc7a",
  ihk_lightgreen: "#cfe0af",
  ihk_lightgrey: "#f8f8f8",
  ihk_darkgrey: "#5f6266",
}
